import React from "react";
import { FC } from "react";
import Scrollbar from "react-scrollbars-custom";
import { Adfit, AdSense } from "component/orgaisms";
import { AdItem } from "types/adDescrition";
import "./styles.styl";

interface AdsSectionProp {
  adItems: AdItem[];
}

const AdsSection: FC<AdsSectionProp> = (props) => {
  const { adItems } = props;
  const noScrollX = true;
  const permanentTrackY = true;
  return (
    <div style={{ height: "100%" }}>
      <Scrollbar
        download=""
        inlist=""
        noScrollX={noScrollX}
        noDefaultStyles
        permanentTrackY={permanentTrackY}
        onContextMenu={(event) => event.preventDefault()}
      >
        {/* <div style={{ marginRight: "10px" }}> */}
        <div className={"ads-item-container"}>
          {!!adItems &&
            adItems.map((adItem) => {
              const { params } = adItem;
              if (adItem.type === "adfit") {
                return <Adfit {...params} />;
              } else if (adItem.type === "adsense") {
                const { client, slot, style } = params;

                return <AdSense client={client} slot={slot} style={style} />;
              } else {
                return <></>;
              }
            })}
        </div>
      </Scrollbar>
    </div>
  );
};

export default AdsSection;
